import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '../../../models/user';
import { ModalService } from '../../../core/modal.service';
import { EditUserModalComponent } from '../edit-user-modal/edit-user-modal.component';

@Component({
  selector: 'cw-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {
  @Input() users: User[];
  @Output() change: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalService: ModalService) {
  }

  showEdit(user: User) {
    const ref = this.modalService.open(EditUserModalComponent);
    ref.componentInstance.initEdit(user);
    ref.result.then((user) => {
      this.change.emit();
    })
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/users/shared/user-list/user-list.component.ts